<fd-dynamic-page>
  <fd-dynamic-page-header />
  <fd-dynamic-page-content>
    <div id="domain-redirect-content">
      <h2>Redirecting...</h2>
      <p>
        In <b>{{ waitingSeconds() }}</b> seconds you are being redirected to
        <a [href]="redirectUrl">{{ redirectUrl }}</a
        >.
      </p>
      <p>Please update your bookmarks!</p>
    </div>
  </fd-dynamic-page-content>
</fd-dynamic-page>
